(function () {
  'use strict';

  function handleSokoraATC(btn) {
    if (!btn || btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      var cardLink = btn.closest('.sokora-card')?.querySelector('a');
      if (cardLink) window.location.href = cardLink.href;
      return;
    }

    var labelSpan = btn.querySelector('span') || btn;
    var originalText = labelSpan.textContent;
    labelSpan.textContent = 'Adding...';
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsToRender = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    var payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sectionsToRender.join(','),
      sections_url: window.location.pathname
    };

    var endpoint = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : (window.routes?.cart_add_url || '/cart/add.js');

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          // Handle error (e.g. sold out)
          labelSpan.textContent = data.description || data.message || 'Error';
          setTimeout(function () {
            labelSpan.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          return;
        }

        labelSpan.textContent = 'Added ✓';
        setTimeout(function () {
          labelSpan.textContent = originalText;
          btn.disabled = false;
        }, 1500);

        // 1. Publish theme pub/sub event
        if (window.publish && window.PUB_SUB_EVENTS) {
          try {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'sokora-collection-card',
              productVariantId: variantId,
              cartData: data
            });
          } catch (e) {
            console.warn(e);
          }
        }

        // 2. Render contents and open cart drawer
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty', 'wt-cart--empty');
          if (data && data.sections && typeof cartDrawer.renderContents === 'function') {
            try {
              var isClosedCart = !cartDrawer.isOpen && !cartDrawer.hasAttribute('open');
              cartDrawer.renderContents(data, isClosedCart);
            } catch (err) {
              console.warn('Error in renderContents:', err);
            }
          }

          // Ensure cart drawer opens
          setTimeout(function () {
            var isStillClosed = !cartDrawer.isOpen && !cartDrawer.classList.contains('wt-cart__drawer--open') && !document.body.classList.contains('page-overlay-cart-on');
            if (isStillClosed) {
              if (typeof cartDrawer.toggleDrawerClasses === 'function') {
                cartDrawer.toggleDrawerClasses();
              } else if (typeof cartDrawer.onToggle === 'function') {
                cartDrawer.onToggle();
              } else {
                var trigger = document.querySelector('.wt-cart__trigger, .header__icon--cart, #cart-icon-bubble');
                if (trigger) trigger.click();
              }
            }
          }, 100);
        } else {
          var cartBubble = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, .header__icon--cart');
          if (cartBubble) cartBubble.click();
        }

        // 3. Dispatch custom events for theme listeners
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: { response: data } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh-complete'));
        }, 200);
      })
      .catch(function (err) {
        console.error('Error adding to cart:', err);
        labelSpan.textContent = originalText;
        btn.disabled = false;
      });
  }

  // Global event delegation - ensures ATC works after filtering, sorting, or pagination
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.sokora-card__atc-btn');
    if (!atcBtn) return;

    e.preventDefault();
    e.stopPropagation();
    handleSokoraATC(atcBtn);
  });
})();
